import { IonList, IonText } from '@ionic/react';
import type {
  GetFantasyLeagueMatchWeekScoresQuery,
  GetFantasyLeagueQuery,
} from '../../../../types/graphql-generated';
import { withAvatarCacheBuster } from '../../../../lib/avatarUrl';
import { FantasyLeagueMember } from './FantasyLeagueMember';

type Standing =
  NonNullable<GetFantasyLeagueMatchWeekScoresQuery['fantasyLeagueMatchWeekScores']>['standings'][number];
type PreviousStanding =
  NonNullable<GetFantasyLeagueMatchWeekScoresQuery['fantasyLeagueMatchWeekScores']>['previousStandings'][number];
type LeagueMember = NonNullable<GetFantasyLeagueQuery['fantasyLeague']>['members'][number];

interface StandingsSegmentProps {
  standings: Standing[];
  previousStandings: PreviousStanding[];
  leadingMemberId: string | null;
  lastMemberId: string | null;
  members: LeagueMember[];
  onMemberClick: (fantasyLeagueMemberId: string) => void;
}

export const StandingsSegment = ({
  standings,
  previousStandings,
  leadingMemberId,
  lastMemberId,
  members,
  onMemberClick,
}: StandingsSegmentProps) => {
  if (standings.length > 0) {
    const previousPositionByMemberId = new Map<string, number>(
      previousStandings.map((s) => [s.fantasyLeagueMember.id, s.position])
    );

    return (
      <IonList>
        {standings.map((standing) => {
          const prevPosition = previousPositionByMemberId.get(standing.fantasyLeagueMember.id);
          let positionChange: 'up' | 'down' | 'same' | null = null;
          if (prevPosition !== undefined) {
            if (standing.position < prevPosition) positionChange = 'up';
            else if (standing.position > prevPosition) positionChange = 'down';
            else positionChange = 'same';
          }

          return (
            <FantasyLeagueMember
              key={standing.id}
              position={standing.position}
              teamName={standing.fantasyLeagueMember.teamName || 'Usuario desconocido'}
              score={standing.totalScore}
              userPicture={withAvatarCacheBuster(
                standing.fantasyLeagueMember.user.picture,
                standing.fantasyLeagueMember.user.updatedAt
              )}
              userName={standing.fantasyLeagueMember.user.fullName ?? undefined}
              isLeader={standing.fantasyLeagueMember.id === leadingMemberId}
              isLast={standing.fantasyLeagueMember.id === lastMemberId}
              positionChange={positionChange}
              onClick={() => onMemberClick(standing.fantasyLeagueMember.id)}
            />
          );
        })}
      </IonList>
    );
  }

  return (
    <>
      <IonText color="medium">
        <p className="ion-padding">No hay clasificación para esta jornada</p>
      </IonText>
      {members.length > 0 && (
        <IonList>
          {members.map((member, index) => (
            <FantasyLeagueMember
              key={member.id}
              userPicture={withAvatarCacheBuster(member.user.picture, member.user.updatedAt)}
              position={index + 1}
              teamName={member.teamName || 'Usuario desconocido'}
              score={undefined}
              onClick={() => onMemberClick(member.id)}
            />
          ))}
        </IonList>
      )}
    </>
  );
};
